import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { toYesOrNo } from '../../../../../../utils/helpers.utils';
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";
import { ORDER_STATUS, CIRCUIT_STATUS } from "../../../../../../constants/external-constants";
import Icons from "../../../../../icon";


export class WirelineOtherDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    editRequest = (orderStatusId, endUserId, requestorId, path) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);

        return editableRequest && isRequestOwner && !path;
    }


    render() {
        const { data, openRequestModal, path } = this.props;
        const { Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId } } = data || {};

        console.log('data', data.BusinessWireline)
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />          
                {this.editRequest(OrderStatusId, EndUserId, RequestorId, path) ?  
                        <>
                        <Icons
                            customClassName="pen-to-square"
                            name="pen-to-square"
                            size="20px"
                            containerClass="icon-circle-plus-container"
                            onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                            labelValue={"Update Order Request"}
                            labelClass="order-detail-edit-label"                                                              
                        />
                        </> 
                        : null 
                    }
                </h4>
                <div className="order-detail-location details-info">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>
                    {data.Order.IsRequestedInBehalf ?
                        <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                    : null}
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="subscription_number" /></td>
                                <td>{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className={data.Circuit.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" : data.Circuit.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Circuit.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Circuit.CircuitTypeName}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="request_details" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="Request" /></td>
                                <td>{data.Order.RequestType.RequestType}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="approver" /></td>
                                <td>{data.WireLineApprover.Email}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="expedite_request" /></td>
                                <td>{toYesOrNo(data.BusinessWireline.ExpediteRequest)}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>

                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}